<template>
	<div>
		<div class="sub_title">
			<h4 class="">{{ title }}</h4>
			<p class="mb_10">
				{{ description }}
			</p>
		</div>
		<div v-for="(field, idx) in fields" :key="field.seq" class="d_flex mb_20">
			<div class="w100">
				<p class="mb_10">{{ field.title }}</p>

				<template
					v-if="readonly || hasApprovedKyc || !field.name.startsWith('KYC_')"
				>
					<div v-if="field.field_type === 'RADIO'">
						<template v-if="readonly">
							<div
								v-if="field.field_seq === 29"
								class="messenger-type d_flex align_items_center"
							>
								<span
									v-if="field_values[idx].value === 'TELEGRAM'"
									class="telegram-icon mr_5"
								></span>
								<span
									v-if="field_values[idx].value === 'LINE'"
									class="line-icon mr_5"
								></span>
								{{ field_values[idx].value }}
							</div>
							<div v-else>
								{{ field_values[idx].value }}
							</div>
						</template>
						<template v-else>
							<div
								class="radio_wrap mr_8"
								v-for="option in field.options"
								:key="option.seq"
							>
								<input
									type="radio"
									:name="`radio_${field.seq}`"
									:id="`radio_${field.seq}_${option.seq}`"
									:value="option.name"
									v-model="field_values[idx].value"
								/>
								<label :for="`radio_${field.seq}_${option.seq}`">{{
									option.title
								}}</label>
							</div>
						</template>
					</div>
					<template
						v-else-if="field.field_seq === 28 && readonly && massenger_info"
					>
						<a class="txt_id" :href="massenger_info.link" target="_blank"
							>Seller Inquiry: {{ massenger_info.link }}</a
						>
					</template>
					<template v-else>
						<input
							type="text"
							:required="!readonly && field.is_required === 'Y'"
							:readonly="readonly"
							v-model="field_values[idx].value"
						/>
					</template>
				</template>
				<template v-else> Available after KYC verification complete </template>
			</div>
		</div>
	</div>
</template>

<script>
import { fetchCertificationList } from '@/api/kyc';
import { commonError } from '@/common/dialog';

export default {
	props: {
		fields: {
			type: Array,
			defayult: () => [],
		},
		title: {
			type: String,
			default: '',
		},
		description: {
			type: String,
			default: '',
		},
		modelValue: {
			type: Array,
			default: () => [],
		},
		readonly: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			hasApprovedKyc: false,
		};
	},
	created() {
		Promise.all([this.loadKyc()]).catch(commonError);
	},
	computed: {
		field_values: {
			get() {
				return this.initFieldValues(this.modelValue);
			},
			set(value) {
				this.$emit('update:modelValue', value);
			},
		},
		massenger_info() {
			const massenger_type = this.field_values.find(
				item => item.field_seq === 29,
			);
			if (
				!massenger_type ||
				!~['TELEGRAM', 'LINE'].indexOf(massenger_type.value)
			)
				return null;

			const messanger_id = this.field_values.find(
				item => item.field_seq === 28,
			);
			if (!messanger_id || !messanger_id.value?.length) return null;

			const links = {
				TELEGRAM: `https://t.me/${messanger_id.value}`,
				LINE: `https://line.me/ti/p/${messanger_id.value}`,
			};

			return {
				link: links[massenger_type.value],
			};
		},
	},
	watch: {
		fields: {
			handler() {
				this.field_values = this.initFieldValues(this.modelValue);
			},
			immediate: true,
		},
	},
	methods: {
		initFieldValues(data) {
			if (data && data.length) return data;

			return this.fields.map(field => ({
				field_seq: field.seq,
				value: '',
			}));
		},
		async loadKyc() {
			const { data } = await fetchCertificationList({
				status: 'APPROVED',
				list_count: 1,
			});

			this.hasApprovedKyc = !!data.length;
		},
	},
};
</script>
